import type { Node } from '@xyflow/react'
import type { GenieCanvasNode } from '@/lib/canvas/types'
import { flowNodeStyle } from '@/lib/canvas/node-box'

/**
 * Convert a GenieCanvasNode (from node factory) to React Flow Node format.
 *
 * This is a pure function — no component state dependencies.
 * New nodes are square: both width and height are set. Height is not left
 * for content measurement, which is what made cards wide rectangles.
 */
export function toReactFlowNode(node: GenieCanvasNode): Node {
  const componentType = node.component?.type || node.type
  return {
    id: node.id,
    type: componentType,
    position: node.position,
    data: {
      state: node.component?.state || {},
      ...(node.data || {}),
      ...(node.handles ? { handles: node.handles } : {}),
    },
    style: flowNodeStyle(componentType, node.dimensions),
    ...(node.parentId ? { parentId: node.parentId, expandParent: true, extent: 'parent' as const } : {}),
  } as Node
}
